module.exports = __webpack_public_path__ + "img/tlc.c366fd90.jpg";